<template>
  <nuxt-page></nuxt-page>
</template>
<script lang="ts">
export default {
  //
};
</script>
